import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", { class: "text-3xl font-semibold mb-16 text-center lg:text-left" }, " Nuestros Servicios ", -1)
const _hoisted_2 = { class: "grid grid-cols-2 md:grid-cols-5" }

import CardComponent from "@/components/base/CardComponent.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ServicesComponent',
  setup(__props) {

const servicesArray = [
  { id: 1, src: "bandera.webp", title: "Pines" },
  { id: 2, src: "bordado.webp", title: "Bordados" },
  { id: 3, src: "esculturas.webp", title: "Esculturas" },
  { id: 4, src: "fundicion.webp", title: "Fundición" },
  { id: 5, src: "grabado.webp", title: "Grabado" },
  { id: 6, src: "joyeria.webp", title: "Joyería" },
  { id: 7, src: "llaveros.webp", title: "Llaveros" },
  { id: 8, src: "monedas.webp", title: "Monedas" },
  { id: 9, src: "placas.webp", title: "Placas" },
  { id: 10, src: "promocional.webp", title: "Promocionales" },
  { id: 11, src: "reconocimiento.webp", title: "Reconocimientos" },
  { id: 12, src: "sublimacion.webp", title: "Sublimación" },
  { id: 13, src: "trofeos.webp", title: "Trofeos" },
  { id: 14, src: "torneado.webp", title: "Torneado" },
  { id: 15, src: "3d.webp", title: "Impresión 3D" },
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(servicesArray, (image) => {
        return _createVNode(CardComponent, {
          key: image.id,
          imageSrc: image.src,
          cardTitle: image.title,
          class: "mb-10"
        }, null, 8, ["imageSrc", "cardTitle"])
      }), 64))
    ])
  ], 64))
}
}

})